import { render, staticRenderFns } from "./sumstat.vue?vue&type=template&id=0a123eb6&"
import script from "./sumstat.vue?vue&type=script&lang=js&"
export * from "./sumstat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports